// extracted by mini-css-extract-plugin
export var noResults = "styles-module--noResults--a5Xqi";
export var noContainer = "styles-module--noContainer--tNfTv";